<span class="status"
      *ngIf="isDisplayableValue(params?.value)"
      [ngClass]="getStatus(params?.value)">
    {{params?.valueFormatted | wepSpaceInCapitalLetters}}
</span>